import PropTypes from 'prop-types';
// material
import { Box } from '@mui/material';

// ----------------------------------------------------------------------

Logo.propTypes = {
  sx: PropTypes.object
};

export default function Logo({ sx }) {
  return <Box component="img" src="https://lh3.googleusercontent.com/d/1KIShrcC2yhbY1OHb7IQczN2VDZ3tf44i" sx={{ width: 40, height: 40, ...sx }} />;
}
